import { useState, useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import '../studiesPage/studyPage.css';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Tooltip from '@mui/material/Tooltip';
import { Zoom } from '@mui/material';


const SiteRequest = ({ setShowSpinner }) => {
  const [data, setData] = useState([]);

  // Bearer Token
  const token = localStorage.getItem('token');
  const tokenValue = token ? token.slice(1, token.length - 1) : '';
  const navigate = useNavigate()

  const getData = () => {
    setShowSpinner(true); // Show the spinner when request starts

    axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/auth/users/false`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${tokenValue}`,
      },
    })
      .then((res) => {
        const response = res.data.data;
        setData(response);
        setShowSpinner(false); // Hide spinner when request is done
      })
      .catch((error) => {
        console.log(error);
        setShowSpinner(false); // Hide spinner even on error
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleClick = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Approve him!',
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedObj = {
          approvedByAdmin: true,
        };
        const url = `https://research-mate-b35a10757d5a.herokuapp.com/api/auth/approveUser/${id}`;
        axios
          .post(url, updatedObj, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${tokenValue}`,
            },
          })
          .then((res) => {
            Swal.fire({
              title: 'Approved!',
              text: 'User has been approved.',
              icon: 'success',
            });
            getData();
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({
              title: 'Something went wrong!',
              text: error.response?.data?.message,
              icon: 'error',
            });
          });
      }
    });
  };

  const handleRouteClick = (url) => {
    if (url === "") {
      Swal.fire({
        title: 'Not Uploaded!',
        text: "This user havn't upload his document yet",
        icon: 'error',
      });
    } else {
      window.open(url);
    }
  }

  return (
    <>
      <div className='p-2'>
        <h4 style={{ color: 'rgb(23 131 131)' }}>Site Request</h4>

        {data.length === 0 ?
          <div className='d-flex justify-content-center align-items-center'>
            <img width={500} height={500} src={require('../../images/nodataImg.webp')} alt="No Data Available" />
          </div>
          :
          <div>
            {data.map((v, i) => {
              return (
                <Card className='mt-2' key={v._id}>
                  <Card.Body>
                    <Row>
                      <Col style={{ maxWidth: '300px' }}>
                        <h6>Name</h6>
                        <p className="ellipsis-text" title={v.firstName + ' ' + v.lastName}>{v.firstName + ' ' + v.lastName}</p>
                      </Col>
                      <Col style={{ maxWidth: '300px' }}>
                        <h6>Email</h6>
                        <p  className="ellipsis-text" title={v.email}>{v.email}</p>
                      </Col>
                      <Col  style={{ maxWidth: '300px' }}>
                        <h6>Organization Name</h6>
                        <p title={v.organizationName} className="ellipsis-text">{v.organizationName}</p>
                      </Col>
                      <Col style={{ maxWidth: '300px' }}>
                        <h6>Organization Type</h6>
                        <p title={v.organizationType}  className="ellipsis-text">{v.organizationType}</p>
                      </Col>
                      <Col style={{ maxWidth: '300px' }}>
                        <h6>Document</h6>
                        <p className="ellipsis-text">
                          <Tooltip title="View Document" arrow
                            TransitionComponent={Zoom}  // Add Zoom transition animation
                            TransitionProps={{
                              timeout: 500,  // Control duration of the animation
                            }}
                          >
                            <Link
                              // to={v.signedDocument}
                              // target='_blank'
                              style={{
                                color: 'black',
                                marginLeft: '37px',
                                fontSize: '9px',
                                cursor: 'pointer',
                              }}
                            >
                              <RemoveRedEyeOutlinedIcon
                                onClick={() => handleRouteClick(v.signedDocument)}
                              />
                            </Link>
                          </Tooltip>
                        </p>
                      </Col>
                      <Col style={{ maxWidth: '300px' }}>
                        <h6>Accept Site</h6>
                        <p className="ellipsis-text">
                          <Tooltip title="Accept Site" arrow
                            TransitionComponent={Zoom}  // Add Zoom transition animation
                            TransitionProps={{
                              timeout: 500,  // Control duration of the animation
                            }}
                          >
                            <CheckCircleOutlineOutlinedIcon
                              style={{
                                marginLeft: '37px',
                                fontSize: '30px',
                                cursor: 'pointer',
                              }}
                              onClick={() => handleClick(v._id)}
                            />
                          </Tooltip>
                        </p>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              );
            })}
          </div>
        }
      </div>
    </>
  );
};

export default SiteRequest;
